import { memo } from 'react';
import './toggleButton.css';

export const ToggleButton = memo(({ items, selectedValue, toggleValue, type }) => {

  const getClass = (active) => {
    if (active) {
      return 'ui-toggle-button ui-toggle-button--active';
    }

    return 'ui-toggle-button';
  }
  return (
    <div className='ui-toggle-wrapper'>
      <label className='ui-toggle-btn-label'>{type}:</label>
      <div className='ui-toggle-main'>
        <button
          className={getClass(selectedValue === items[0])}
          name={items[0]}
          onClick={(event) => toggleValue(event, type)}
        >
          {items[0]}
        </button>
        <button
          className={getClass(selectedValue === items[1])}
          name={items[1]}
          onClick={(event) => toggleValue(event, type)}
        >
          {items[1]}
        </button>
      </div>
    </div>
  )
})
